import moment from 'moment'

import ConfirmationDialog from '../../../../components/ReusableComponents/ConfirmationDialog/index'
import { capitalizeFirstLetter } from '../../../../utils/helpers'
import styles from './GenericWarning.module.scss'

const GenericWarning = ({ type, sentDate, sendBy, ...props }) => (
  <ConfirmationDialog
    {...props}
    positiveMessage={type === 'resend' ? 'Resend' : 'Edit anyways'}
    negativeMessage="Back"
    title={`Are you sure you want to ${type}?`}
  >
    <p className={styles.p}>
      This invoice is already sent on <strong>{moment(sentDate).format('MMM D')}</strong>{' '}
      by <strong>{sendBy}</strong>. {capitalizeFirstLetter(type)} only if hotel requested
      a reconciliation.
    </p>
  </ConfirmationDialog>
)

export default GenericWarning
